import { dollarFormatter } from "../utils";
import { format } from "date-fns";
import { Status } from "components/status";
import { SubtleIconButton } from "../components/button";
import { RiMore2Line } from "react-icons/ri";
import Placeholder from "../views/request/component/placeholder";
import Table, { useTable } from "components/table";
import { useHistory } from "react-router";
import { TEstimate } from "types/estimate";
import { useTranslation } from 'react-i18next';
import { enUS, es } from "date-fns/locale";
import { useAuthContext } from "contexts/auth";
import convertCVD  from "../utils/convertCVD";

type Status = {
  color: string;
  label: string;
};

export default function EstimateSection<T>(props: {
  data: TEstimate[] | null;
  table?: any;
  pageCount?: number;
}) {
  const { t, i18n } = useTranslation();
  const tBase = "containers.estimatesList";
  const tr = (key: string) => t(`${tBase}.${key}`);
  const { cvd_type } = useAuthContext();

  const history = useHistory();

  const locale = i18n.language === "es" ? es : enUS;

  const columns = {
    id: {
      label: tr("Estimate #"),
      width: "8em",
      minWidth: "8em",
      maxWidth: "8em",
      style: {
        maxWidth: "8em",
      },
    },
    status: {
      label: tr("Status"),
      width: "12em",
      minWidth: "12em",
      maxWidth: "12em",
      style: {
        maxWidth: "10em",
      },
      cell: (row: any) => {
        const statusColor = convertCVD(row.status.color, cvd_type);
        return <Status color={statusColor}>{tr(row.status.label)}</Status>
      },
    },
    description: {
      label: tr("Description"),
      width: "15em",
      minWidth: "15em",
      maxWidth: "15em",
      style: {
        maxWidth: "15em",
      }
    },
    customer: {
      width: "10em",
      minWidth: "10em",
      maxWidth: "10em",
      style: {
        maxWidth: "10em",
      },
      label: tr("Customer"),
    },
    manager: {
      width: "10em",
      minWidth: "10em",
      maxWidth: "10em",
      style: {
        maxWidth: "10em",
      },
      label: tr("Manager"),
    },
    entry_date: {
      width: "10em",
      minWidth: "10em",
      maxWidth: "10em",
      style: {
        maxWidth: "10em",
      },
      label: tr("Entry Date"),
      cell: (row: any) =>
        format(new Date(row.entry_date), "MMM dd, yyyy", {
          locale: locale,
        }),
    },
    date_won: {
      width: "10em",
      minWidth: "10em",
      maxWidth: "10em",
      style: {
        maxWidth: "10em",
      },
      label: tr("Date Won"),
      cell: (row: any) =>
        row.won_date
          ? format(new Date(row.won_date), "MMM dd, yyyy", {
            locale: locale,
          })
          : "",
    },
    
  stats: {
  label: tr("Request Stats"),
  width: "5rem",
  minWidth: "5rem",
  maxWidth: "5rem",
  style: {
    maxWidth: "5rem",
  },
  cell: (row: TEstimate) => {
  const max = Math.max(
    row.request_total || 0,
    row.invoice_total || 0,
    row.paid_total || 0,
    1
  );

  const requestW = ((row.request_total || 0) / max) * 60;
  const invoiceW = ((row.invoice_total || 0) / max) * 60;
  const paidW = ((row.paid_total || 0) / max) * 60;

    return (
      <div className="flex flex-col w-[70px]">
        {requestW !== 0 && (
          <div className="flex items-center">
            <span className="text-[0.6rem] font-bold w-[10px] flex-none leading-none">
              W
            </span>
            <div
              className="rounded h-[3px] bg-red-500"
              style={{ width: `${requestW}px` }}
            />
          </div>
        )}

        {invoiceW !== 0 && (
          <div className="flex items-center">
            <span className="text-[0.6rem] font-bold w-[10px] flex-none leading-none">
              I
            </span>
            <div
              className="rounded h-[3px] bg-purple-500"
              style={{ width: `${invoiceW}px` }}
            />
          </div>
        )}

        {paidW !== 0 && (
          <div className="flex items-center">
            <span className="text-[0.6rem] font-bold w-[10px] flex-none leading-none">
              P
            </span>
            <div
              className="rounded h-[3px] bg-green-500"
              style={{ width: `${paidW}px` }}
            />
          </div>
        )}
      </div>
    );
  },
},
  };
  

  return (
    <div>
      {props.data && props.data.length > 0 ? (
        <Table
          data={props.data}
          columns={columns}
          handleClick={(row: any) => history.push(`/estimates/${row.id}`)}
          pageCount={props.pageCount}
          {...props.table}
        />
      ) : (
        <Placeholder
          type="estimate"
          header={tr("No estimate yet")}
          label={tr("When you add estimates to the request, they will appear here.")}
        />
      )}
    </div>
  );
}
